module.exports = __webpack_public_path__ + "static/turtle-creek-house09-f18d4a217d97392ae101c0a6f2405d4d.jpg";